import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '@environments/environment';
import { INDRABFMDataStorageService } from '@ibe.services/bfm-data-storage.indra.service';
// import { BusTripModalComponent } from '@ibe.components/shared/bus-trip-modal/bus-trip-modal.component';
import { BookingService } from '@ibe.services/booking.tap.service';
import { INDRACurrencyService } from '@ibe.services/currency.indra.service';
import { INDRAIbeAdminService } from '@ibe.services/ibeadmin.indra.service';
import { BookedTrip } from '@ibe/models';
import { ModalService, SidebarService } from '@ibe/services/ui';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { takeWhile } from 'rxjs/operators';
import * as fromStore from '../../../../store';
import * as _ from 'lodash';


@Component({
	selector: 'app-time-to-think',
	templateUrl: './time-to-think.indra.component.html',
	styleUrls: ['./time-to-think.component.scss']
})
export class INDRATimeToThinkComponent implements OnInit, OnDestroy {

	isAlive = true;
	booking_trip$: Observable<BookedTrip> = this.store.select(fromStore.getSelectedBookedTrip);
	bookedTripDiscounts$: Observable<any> = this.store.select(fromStore.getSelectedBookedTripDiscounts);
	bookedTripDiscounts: Array<any> = [];
	currency;
	booking_trip: BookedTrip;
	totalPrice: number;

	timeToThinkOptions;
	tttList;

	constructor(
		private bookingService: BookingService,
		private store: Store<fromStore.State>,
		private router: Router,
		private sidebarService: SidebarService,
		protected modalService: ModalService,
		private bfmStorage: INDRABFMDataStorageService,
		private currencyService: INDRACurrencyService,
		protected ibeAdminService: INDRAIbeAdminService,
	) {
		this.booking_trip$
			.pipe(takeWhile(() => this.isAlive))
			.subscribe(value => this.booking_trip = value);

		this.bookedTripDiscounts$
			.pipe(takeWhile(() => this.isAlive))
			.subscribe(discounts => {
				this.bookedTripDiscounts = Object.assign([], discounts);
			});

		this.totalPrice = this.INDRA_getSelectedFlightTotalPrice();
		this.currency = this.currencyService.INDRA_getCurrencySymbol().unit;
	}

	ngOnDestroy() {
		this.isAlive = false;
	}

	ngOnInit() {
		this.tttList = this.bfmStorage.INDRA_getTimeToThinkOptions();		
		this.INDRA_constructTTTOptions(this.tttList);
	}

	INDRA_constructTTTOptions(list) {
		list.sort((a, b) => a.validity - b.validity);
		this.timeToThinkOptions = list.map(opt => {
			const validity = this.INDRA_formatValidityHours(opt.validity);
			return {
				label: validity,
				value: this.INDRA_getTranslationKey('availability.timeToThink.text.add') + ' ' + validity + ' ' +
				this.INDRA_getTranslationKey('availability.timeToThink.text.toThink') + ' ' + '(' + opt.totalFee + this.currency + ')',
				code: opt.code
			}
		})
	}

	INDRA_formatValidityHours(validity) {
		if (validity && validity > 48) {
			const days = validity / 24;
			return days + ' ' + this.INDRA_getTranslationKey('availability.timeToThink.text.days');
		}
		return validity + ' ' + this.INDRA_getTranslationKey('availability.timeToThink.text.hours');;
	}


	INDRA_goTTT(code) {
		const selectedTimeToThink = this.tttList.find(option => option.code === code);
		
		this.bfmStorage.INDRA_setTimeToThink(selectedTimeToThink);
		this.bfmStorage.INDRA_setTimeToThinkCode(code);
		this.INDRA_handleClose();
	}

	INDRA_handleClose() {
		this.sidebarService.closeSidebar();
		this.router.navigate([{ outlets: { sidebar: null } }], { replaceUrl: true });
	}

	INDRA_getTranslationKey(key: string): string {
		return this.ibeAdminService.getTranslationValue(key);
	}

	INDRA_getSelectedFlightTotalPrice() {
		const FlightInfo = _.cloneDeep(this.booking_trip.flights);
		let priceTotal: any = FlightInfo.map( flight => {
			return flight.options.price;
		});

		priceTotal = (priceTotal && priceTotal.length > 0) ?
			parseFloat(priceTotal.reduce((a, b) => a + b).toString()).toFixed(2) : 0;

		if (this.bookedTripDiscounts.length != 0) {
			let totalDiscount: number = 0;
			for (const i in this.bookedTripDiscounts) {
				totalDiscount = totalDiscount + +this.bookedTripDiscounts[i].value;
			}
			const totalDiscountedPrice = priceTotal - totalDiscount < 0 ? 0 : priceTotal - totalDiscount;
			priceTotal = totalDiscountedPrice.toFixed(2);
		}

		return priceTotal;
	}
}